// License template store
import { defineStore } from "pinia";
import { TemplateOut } from '@/client/types';
import { TemplateApiClient } from "@/client/requests";

export const useLicenseTemplateStore = defineStore('licenseTemplate', {
    state: () => ({
      template : null as TemplateOut | null,
    }),
    actions: {
      async fetchTemplates() {
        const client = new TemplateApiClient();
        this.template = await client.getAll();
      }
    },
});